import React, { useState, useEffect } from "react";
import Joyride from "react-joyride";
import { steps } from "./tour-config";
import "../layout.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "../assets/logoesia.PNG";
import agalogo from "../assets/aga.jpg";

import {
  RiGroup3Line,
  RiHospitalLine,
  RiLogoutCircleRLine,
  RiUserAddLine,
  RiChatHistoryLine,
  RiQrScan2Line,
  RiSettings2Line,
  RiDatabase2Line,
  RiUserLine,
  RiRefreshLine,
  RiGroupLine,
  RiDashboardLine,
  RiQuestionLine,
  RiNotification3Line, // Add notification icon
  RiQuestionAnswerLine, // Add message icon
} from "@remixicon/react";
import ChatButton from "./ChatButton";

function Layout({ children, unreadCount }) {
  const { user } = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(true);
  const [messageCount, setMessageCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const [logoURL, setLogoURL] = useState("");
  // const [sidebarColor, setSidebarColor] = useState("#3c387f");
  const [runTour, setRunTour] = useState(false);

  // useEffect(() => {
  //   const getSettings = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}/auth/get-settings`,
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: "Bearer " + localStorage.getItem("token"),
  //           },
  //         }
  //       );

  //       const parseRes = await response.json();
  //       if (parseRes.success) {
  //         setLogoURL(parseRes.data.logo);
  //         setSidebarColor(parseRes.data.sidebar_color);
  //         console.log("Sidebar color: ", parseRes.data.sidebar_color);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching Settings:", error);
  //     }
  //   };

  //   getSettings();
  // }, []);

  useEffect(() => {
    const fetchMessageCount = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/unread-messages-count`,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        const result = await response.json();
        if (result.success) {
          setMessageCount(result.count);
          console.log("message count: ", result.count);
        }
      } catch (error) {
        console.error("Error fetching message count:", error);
      }
    };

    fetchMessageCount();
  }, []);

  const handleLogout = () => {
    localStorage.clear(); // Clear any stored data
    navigate("/"); // Redirect to login page
    window.location.reload(); // Force a full reload to reset state
  };

  const handleUserNameClick = () => {
    console.log("User object:", user); // Log the entire user object
    console.log("User ID:", user ? user.user_id : "User ID is undefined"); // Log the user ID

    if (user && user.user_id) {
      navigate(`/user-detail/${user.user_id}`);
    } else {
      console.error("User ID is not available");
    }
  };

  const handleMessagesClick = () => {
    navigate("/messages"); // Navigate to the messages page
  };

  useEffect(() => {
    if (user) {
      setIsLoading(false);
      console.log("User Type:", user);
    }
  }, [user]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const handleStartTour = () => {
    setRunTour(true); // Trigger the tour
  };

  return (
    <div className="main">
      <div className="d-flex layout">
        <div className="sidebar">
          <div className="sidebar-header">
            <h3 className="d-flex justify-content-center mt-3">
              {logoURL ? (
                <img
                  src={`http://localhost:3000/Images/Logo/` + logoURL}
                  className="logo-photo"
                  alt=""
                />
              ) : (
                <img src={logo} className="logo-photo" alt="" />
              )}
            </h3>
          </div>
          <div className="menu">
            {user?.type === "Admin" ? (
              <>
                <div
                  className={`d-flex menu-item menu-item-dashboard ${
                    currentPath === "/dashboard" ? "active-menu-item" : ""
                  }`}
                  data-tooltip-id="tooltip"
                  data-tooltip-content="dashboard"
                >
                  <RiDashboardLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/dashboard">Tableau de bord</Link>
                </div>

                <div
                  className={`d-flex menu-item menu-item-patients ${
                    currentPath === "/member-list" ? "active-menu-item" : ""
                  }`}
                >
                  <RiHospitalLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/member-list">Patients</Link>
                </div>
                <div
                  className={`d-flex menu-item menu-item-users ${
                    currentPath === "/user-list" ? "active-menu-item" : ""
                  }`}
                >
                  <RiGroupLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/user-list">Utilisateurs</Link>
                </div>
                <div
                  className={`d-flex menu-item menu-item-database ${
                    currentPath === "/database-processing"
                      ? "active-menu-item"
                      : ""
                  }`}
                >
                  <RiDatabase2Line
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/database-processing">Traitement Données</Link>
                </div>
                <div
                  className={`d-flex menu-item menu-item-scan ${
                    currentPath === "/scan-card" ? "active-menu-item" : ""
                  }`}
                >
                  <RiQrScan2Line
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/scan-card">Scan Card</Link>
                </div>
                <div
                  className={`d-flex menu-item menu-item-history ${
                    currentPath === "/history" ? "active-menu-item" : ""
                  }`}
                >
                  <RiChatHistoryLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/history">Historique</Link>
                </div>
                {/* <div
                  className={`d-flex menu-item menu-item-update ${
                    currentPath === "/update-data" ? "active-menu-item" : ""
                  }`}
                >
                  <RiRefreshLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/update-data">Mise à jour données</Link>
                </div> */}

                <div
                  className={"d-flex menu-item menu-item-logout"}
                  onClick={handleLogout}
                >
                  <RiLogoutCircleRLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/">Deconnexion</Link>
                </div>
              </>
            ) : user?.type === "User" ? (
              <>
                <div
                  className={`d-flex menu-item menu-item-dashboard ${
                    currentPath === "/dashboard" ? "active-menu-item" : ""
                  }`}
                  data-tooltip-id="tooltip"
                  data-tooltip-content="dashboard"
                >
                  <RiDashboardLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/dashboard">Tableau de bord</Link>
                </div>

                <div
                  className={`d-flex menu-item menu-item-patients ${
                    currentPath === "/member-list" ? "active-menu-item" : ""
                  }`}
                >
                  <RiHospitalLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/member-list">Patients</Link>
                </div>

                <div
                  className={`d-flex menu-item menu-item-scan ${
                    currentPath === "/scan-card" ? "active-menu-item" : ""
                  }`}
                >
                  <RiQrScan2Line
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/scan-card">Scan Card</Link>
                </div>
                <div
                  className={`d-flex menu-item menu-item-history ${
                    currentPath === "/history" ? "active-menu-item" : ""
                  }`}
                >
                  <RiChatHistoryLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/history">Historique</Link>
                </div>

                <div
                  className={"d-flex menu-item menu-item-logout"}
                  onClick={handleLogout}
                >
                  <RiLogoutCircleRLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/">Deconnexion</Link>
                </div>
              </>
            ) : user?.type === "Afl" ? (
              <>
                <div
                  className={`d-flex menu-item menu-item-dashboard ${
                    currentPath === "/dashboard" ? "active-menu-item" : ""
                  }`}
                  data-tooltip-id="tooltip"
                  data-tooltip-content="dashboard"
                >
                  <RiDashboardLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/dashboard">Tableau de bord</Link>
                </div>

                <div
                  className={`d-flex menu-item menu-item-patients ${
                    currentPath === "/member-list" ? "active-menu-item" : ""
                  }`}
                >
                  <RiGroup3Line
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/member-list">Employés</Link>
                </div>

                <div
                  className={`d-flex menu-item menu-item-database ${
                    currentPath === "/database-processing"
                      ? "active-menu-item"
                      : ""
                  }`}
                >
                  <RiDatabase2Line
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/database-processing">Traitement Données</Link>
                </div>

                <div
                  className={`d-flex menu-item menu-item-history ${
                    currentPath === "/history" ? "active-menu-item" : ""
                  }`}
                >
                  <RiChatHistoryLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/history">Historique</Link>
                </div>

                <div
                  className={"d-flex menu-item menu-item-logout"}
                  onClick={handleLogout}
                >
                  <RiLogoutCircleRLine
                    color="rgba(255, 255, 255, 0.73)"
                    className="my-icon"
                    size={20}
                  />
                  <Link to="/">Deconnexion</Link>
                </div>
              </>
            ) : (
              "null"
            )}
          </div>
        </div>
        <div className="content">
          <div className="header d-flex justify-content-between align-items-center">
            <div>
              <RiQuestionLine
                className="guide-icon"
                size={24}
                onClick={handleStartTour}
              />
            </div>

            <div className="user-info d-flex align-items-center">
              {user?.type === "Admin" && (
                <>
                  <RiQuestionAnswerLine
                    className="notification-icon"
                    size={24}
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/messages")}
                  />
                  {messageCount > 0 && (
                    <div className="notification-badge">
                      {unreadCount || messageCount}
                    </div>
                  )}
                </>
              )}

              {user?.type === "Afl" && (
                <>
                  <RiQuestionAnswerLine
                    className="notification-icon"
                    size={24}
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/messages")}
                  />
                </>
              )}
              <RiUserLine
                color="white"
                size={20}
                style={{ marginRight: "10px" }}
              />
              <span
                onClick={handleUserNameClick}
                style={{ cursor: "pointer" }}
                className="user-name"
              >
                {user?.firstname} {user?.lastname}
              </span>
            </div>
          </div>
          <div className="body">{children}</div>
          <div className="footer d-flex justify-content-between align-items-center px-5">
            <div style={{ height: "90%" }}>
              <img style={{ height: "100%" }} src={agalogo} />
            </div>

            <div>
              <p className="footer-text">
                &copy; Prestatech Sarlu - {"  "}
                <span
                  style={{
                    fontWeight: 900,
                    fontSize: "0.6875rem",
                  }}
                >
                  prestatech@espacehitech.mg
                </span>
              </p>
            </div>
            <div>
              <p className="footer-text">
                AGA (Application de Gestion d'Affilié) - Version 1.0.0
              </p>
            </div>
          </div>
        </div>
      </div>
      <Joyride
        steps={steps}
        run={runTour}
        continuous
        scrollToFirstStep
        showSkipButton
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      />
      {/* Add the Chat Button */}
      {user?.type === "Afl" && <ChatButton />}
    </div>
  );
}

export default Layout;
